"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordAttrFormatter = recordAttrFormatter;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const isObject_js_1 = require("../../../utils/validation/isObject.js");
const attribute_js_1 = require("./attribute.js");
const formatter_js_1 = require("./formatter.js");
const utils_js_1 = require("./utils.js");
function* recordAttrFormatter(attribute, rawValue, { attributes, valuePath = [], ...restOptions } = {}) {
    const { format = true, transform = true } = restOptions;
    if (!(0, isObject_js_1.isObject)(rawValue)) {
        const { type } = attribute;
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('formatter.invalidAttribute', {
            message: `Invalid attribute detected while formatting${path !== undefined ? `: '${path}'` : ''}. Should be a ${type}.`,
            path,
            payload: { received: rawValue, expected: type }
        });
    }
    const formatters = [];
    for (const [key, element] of Object.entries(rawValue)) {
        if (element === undefined) {
            continue;
        }
        // NOTE: If transform is true, `key` is the transformed value which is what we want
        // If not, `key` should already be formatted, which is what we also want
        const elmtValuePath = [...valuePath, key];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const formattedKey = new formatter_js_1.Formatter(attribute.keys).format(key, {
            transform,
            valuePath: elmtValuePath
        });
        const sanitizedKey = (0, utils_js_1.sanitize)(formattedKey);
        const { isProjected, childrenAttributes } = (0, utils_js_1.matchProjection)(new RegExp(`^\\.${sanitizedKey}|^\\['${sanitizedKey}']`), attributes);
        if (!isProjected) {
            continue;
        }
        formatters.push([
            formattedKey,
            (0, attribute_js_1.attrFormatter)(attribute.elements, element, {
                attributes: childrenAttributes,
                valuePath: elmtValuePath,
                ...restOptions
            })
        ]);
    }
    if (transform) {
        const transformedValue = Object.fromEntries(formatters
            .map(([key, formatter]) => [key, formatter.next().value])
            .filter(([, element]) => element !== undefined));
        if (format) {
            yield transformedValue;
        }
        else {
            return transformedValue;
        }
    }
    const formattedValue = Object.fromEntries(formatters
        .map(([key, formatter]) => [key, formatter.next().value])
        .filter(([, element]) => element !== undefined));
    return formattedValue;
}
